export const version = '0.508.3'
export const chameleonWebVersion = '3.32.5'
export const chameleonCoreVersion = '2.20.0'
